<template>
  <div class="level">
    <qd-collapse class="column is-5 is-paddingless" >
      <div class="columns is-multiline is-marginless subMenu">
        <div class="column is-12 is-paddingless">
          <div class="level-right">
            <button @click="close()" class="button is-subMenu">
              <b-icon icon="close"
                      custom-size="mdi-10px"
                      type="is-white">
              </b-icon>
            </button>
          </div>
          <display-menu-and-sub-menu :menuAndSubMenu="logistiqueMenu">
          </display-menu-and-sub-menu>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import remove from 'lodash/remove';
import displayMenuAndSubMenu from '@/components/sideBar/submenuSidebar/displayMenuAndSubMenu';
import * as permLogistique from '@/configuration/logistique/permissionsLogistiqueConf';
import {
  SET_INDEX_SUB_MENU_OPEN,
  SET_LOGISTIC_MENU,
} from '@/store/modules/menu/menu-mutation-type';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  MENU_LOGISTIQUE_TECHNIQUE,
  MENU_AUDIT_TECHNIQUE,
  SOUS_MENU_TECHNICIEN,
  MENU_LOGISTIQUE_PARAMETRAGE,
  SOUS_MENU_PROJET,
  MENU_DEMANDE_IMPRESSION,
  SOUS_MENU_EXPEDITION,
  SOUS_MENU_OT_IMPRESSION,
  MENU_SUIVI_PRODUCTION,
} from '@/configuration/logistique/menuLogistiqueConf';
import messageErreur from '@/services/general/messageErreur';

const menu = createNamespacedHelpers('menu');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'SidebarLogistique',
  components: {
    displayMenuAndSubMenu,
  },
  data() {
    return {
      logistiqueMenu: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    previsionDepartCBA() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.previsionnelDepartCBA.key);
    },
    logistique() {
      const previsionnelDepartRoute = {
        name: 'sidebar.logistique.previsionnelDepart',
        path: 'l.logistique.previsionnel-depart',
        perm: permLogistique.PREVISIONNEL_DEPART.lecture,
      };
      if (this.previsionDepartCBA) {
        previsionnelDepartRoute.path = 'l.logistique.previsionnel-departCBA';
      }
      return [
        {
          title: 'sidebar.logistique.demandeIntervention',
          noSubMenu: true,
          perm: permLogistique.INTERVENTION.lecture,
          path: 'l.logistique.demande_intervention',
        },
        {
          title: 'sidebar.logistique.demandeImpression',
          noSubMenu: true,
          perm: permLogistique.DEMANDE_IMPRESSION.lecture,
          path: 'l.logistique.demande_impression',
        },
        {
          title: MENU_SUIVI_PRODUCTION,
          noSubMenu: true,
          perm: permLogistique.SUIVI_PRODUCTION.lecture,
          path: 'l.logistique.suivi_production',
        },
        {
          title: 'sidebar.logistique.logistiqueAff',
          noSubMenu: false,
          data: [
            previsionnelDepartRoute,
            { name: 'sidebar.logistique.demandeAffectation', path: 'l.logistique.demande-auto', perm: permLogistique.DEMANDE.lecture },
            { name: 'sidebar.logistique.chargeTravailAff', path: 'l.logistique.charge_travail-affichage', perm: permLogistique.CHARGE_TRAVAIL.lecture },
            { name: 'sidebar.logistique.ordreTravailAff', path: 'l.logistique.ordre_travail-affichage', perm: permLogistique.ORDRE_TRAVAIL.lecture },
            { name: 'sidebar.logistique.listeAffectationLogistique', path: 'l.logistique.affectation-logistique', perm: permLogistique.AFFECTATION.lecture },
          ],
        },
        {
          title: MENU_LOGISTIQUE_TECHNIQUE,
          noSubMenu: false,
          data: [
            {
              name: 'sidebar.logistique.chargeTravailTech',
              path: 'l.logistique.charge_travail-tech',
              perm: permLogistique.CHARGE_TRAVAIL.lecture,
            },
            {
              name: 'sidebar.logistique.ordreTravailTech',
              path: 'l.logistique.ordre_travail-tech',
              perm: permLogistique.ORDRE_TRAVAIL.lecture,
            },
            { name: SOUS_MENU_PROJET, path: 'l.logistique.projets', perm: permLogistique.ORDRE_TRAVAIL.lecture },
            {
              name: 'sidebar.logistique.ordreTravailImpression',
              path: 'l.logistique.ordre_travail_impression',
              perm: permLogistique.ORDRE_TRAVAIL.lecture,
            },
            {
              name: 'sidebar.logistique.expedition',
              path: 'l.logistique.ordre_travail_expedition',
              perm: permLogistique.ORDRE_TRAVAIL_EXPEDITION.lecture,
            },
          ],
        },
        {
          title: 'sidebar.logistique.audit',
          noSubMenu: true,
          perm: permLogistique.ORDRE_TRAVAIL_AUDIT.lecture,
          path: 'l.logistique.ordre_travail_audit',
        },
        {
          title: MENU_LOGISTIQUE_PARAMETRAGE,
          noSubMenu: false,
          data: [
            { name: 'sidebar.logistique.afficheur', path: 'l.logistique.afficheur', perm: permLogistique.AFFICHEUR.lecture },
            { name: 'sidebar.logistique.tourneeAffichage', path: 'l.logistique.tournee_modele', perm: permLogistique.TOURNEE_MODELE.lecture },
            { name: SOUS_MENU_TECHNICIEN, path: 'l.logistique.technicien', perm: permLogistique.TECHNICIEN.lecture },
          ],
        },
      ];
    },
  },
  methods: {
    ...menu.mapMutations({
      setLogisticMenu: SET_LOGISTIC_MENU,
      setIndexSubMenu: SET_INDEX_SUB_MENU_OPEN,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    close() {
      this.setLogisticMenu(false);
      this.setIndexSubMenu(null);
    },
    getLogistiqueMenu() {
      const tabLogistique = this.logistique;
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key)) {
        remove(tabLogistique, menu => menu.title === MENU_LOGISTIQUE_TECHNIQUE);
        const indexMenuParametrage = tabLogistique
          .findIndex(menu => menu.title === MENU_LOGISTIQUE_PARAMETRAGE);
        remove(
          tabLogistique[indexMenuParametrage].data,
          item => item.name === SOUS_MENU_TECHNICIEN,
        );
      }
      const indexMenuLogistique = tabLogistique
        .findIndex(menu => menu.title === MENU_LOGISTIQUE_TECHNIQUE);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique
        .key) && indexMenuLogistique !== -1) {
        remove(
          tabLogistique[indexMenuLogistique].data,
          item => item.name === SOUS_MENU_PROJET,
        );
      }
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key)
        && indexMenuLogistique !== -1) {
        remove(
          tabLogistique[indexMenuLogistique].data,
          item => item.name === SOUS_MENU_OT_IMPRESSION,
        );
        remove(
          tabLogistique[indexMenuLogistique].data,
          item => item.name === SOUS_MENU_EXPEDITION,
        );
      }
      const indexMenuAudit = tabLogistique
        .findIndex(menu => menu.title === MENU_AUDIT_TECHNIQUE);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.affixeMobile.key)
        && indexMenuAudit !== -1) {
        remove(tabLogistique, menu => menu.title === MENU_AUDIT_TECHNIQUE);
      }
      const indexMenuDemandeImpression = tabLogistique
        .findIndex(menu => menu.title === MENU_DEMANDE_IMPRESSION);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key)
        && indexMenuDemandeImpression !== -1) {
        remove(tabLogistique, menu => menu.title === MENU_DEMANDE_IMPRESSION);
      }
      const indexMenuSuiviProduction = tabLogistique
        .findIndex(menu => menu.title === MENU_SUIVI_PRODUCTION);
      if (!this.parametresInterne(PARAMETRES_INTERNE_KEYS.demandeImpression.key)
        && indexMenuSuiviProduction !== -1) {
        remove(tabLogistique, menu => menu.title === MENU_SUIVI_PRODUCTION);
      }
      return tabLogistique;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.afficherLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique.key,
        PARAMETRES_INTERNE_KEYS.affixeMobile.key,
        PARAMETRES_INTERNE_KEYS.previsionnelDepartCBA.key,
        PARAMETRES_INTERNE_KEYS.demandeImpression.key,
      ]);
      this.logistiqueMenu = this.getLogistiqueMenu();
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
